import axios from 'axios';
import authHeader from './authHeader';
import { API_URL } from '../utils/baseApi';

export const getProjectImages = () => {
  const apiKey = localStorage.getItem('apiKey');
  return axios.get(`${API_URL}/project-images`, {
    headers: { 'x-api-key': apiKey }
  });
};

export const upsertProjectImage = ({ projectName, image, gameId }) => {
  return axios.post(`${API_URL}/project-images/upsert`, { projectName, image, gameId }, {
    headers: authHeader()
  });
};

export const getProjectImagesByGame = (gameId) => {
  const apiKey = localStorage.getItem('apiKey');
  return axios.get(`${API_URL}/project-images/by-game/${gameId}`, {
    headers: { 'x-api-key': apiKey }
  });
};

export default { getProjectImages, upsertProjectImage, getProjectImagesByGame };
